import { Component } from "../ecs";

export class EditorControlComponent implements Component {
  x: number;
  y: number;
}
